var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuditIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 7,
    viewBox: "0 0 62 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33521 0V6.91641H5.17875V4.47465H2.15603V6.91765H0V0.000411765H2.15603V2.35818H5.17875V0H7.33521ZM28.7283 0V1.96412H22.964V4.95271H28.7296V6.91682H22.964V6.91765H20.7831V0.000411765H21.862V0H28.7283ZM56.5628 0V0.00452941L56.5689 0L59.5781 2.97418V0H61.738V6.91765H59.5781L56.5628 3.84547V6.91765H54.4028V0H56.5628ZM40.9549 0V2.35447L38.8351 4.40259H40.9527V6.91765H38.6823V4.46971H35.2789V6.91765H33.0084V0.00123529H35.2789V2.35447H38.6845V0H40.9549ZM17.3469 0V0.000411765H17.7268V6.91765H15.5873V5.42006H12.531V6.91765H10.3915V0.000411765H10.6107V0H17.3473H17.3469ZM51.3465 0V1.96206H46.1511V2.478H51.3338V4.44006H46.1511V4.95559H51.3329V6.91765H44.5963V6.916H44.0113V0H44.6094H51.3465ZM15.5873 1.96412H12.531V3.37565H15.5873V1.96412Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditIcon2);
export default __webpack_public_path__ + "static/media/auditIcon2.4983016379e31dccbc50c323c76207d4.svg";
export { ForwardRef as ReactComponent };